import { render } from "./PlanillaSinArchivo.vue?vue&type=template&id=6808f313&scoped=true"
import script from "./PlanillaSinArchivo.vue?vue&type=script&lang=js"
export * from "./PlanillaSinArchivo.vue?vue&type=script&lang=js"

import "./PlanillaSinArchivo.vue?vue&type=style&index=0&id=6808f313&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6808f313"]])

export default __exports__